import { Component, OnInit } from '@angular/core';

import { TaskList, TaskListItem } from '../tasks';
import { TaskService } from '../task.service';

@Component({
  selector: 'app-task-list',
  templateUrl: './task-list.component.html',
  styleUrls: ['./task-list.component.scss']
})
export class TaskListComponent implements OnInit {
  tasks: Array<TaskListItem>;
  loading: boolean;
  rowlimit = 10;
	taskStatus = {OverDue : 1, Warning : 2 , OnTime : 3, Complete : 4, NC: 5, Paused : 6, UA : 7, Processing : 120};
	searchText = '';

  constructor(private _taskListSvc: TaskService) {}

  ngOnInit() {
    this.loading = true;
    (<any>this)._taskListSvc
      .getTasksByPropertyId()
      .subscribe(res => {
        this.loading = false;
        this.tasks = res.data;
        this.rowlimit = res.meta.pagination.PageSize || this.rowlimit;
      });
  }

	clearSearchBox(obj): void {
		this.searchText = '';
		obj.filterGlobal('', 'contains');
	}

	canAccessTask(taskStatus: number, CanOperatorCompleteTask: boolean) {
		var accessibleTaskStatus = {OverDue : 1, Warning : 2 , OnTime : 3, Complete : 4};
		var nonAccessibleTaskStatus = {NC: 5, Paused : 6, UA : 7, Processing : 120};
		var aAccessibleStatus = Object.keys(accessibleTaskStatus).map(function(e) {
			return accessibleTaskStatus[e];
		});
		var aNonAccessibleStatus = Object.keys(nonAccessibleTaskStatus).map(function(e) {
			return nonAccessibleTaskStatus[e];
		});

		if (aAccessibleStatus.indexOf(taskStatus) !== -1) {
			if (taskStatus === this.taskStatus.Complete) {
				return true;
			} else if (typeof CanOperatorCompleteTask === 'undefined' || !CanOperatorCompleteTask) {
				return false;
			}
		}
		if (aNonAccessibleStatus.indexOf(taskStatus) !== -1) {
			return false;
		}
		return true;
	}
	
	getDueCompleteSuffix(task:TaskListItem){
		let dueCompleteSuffix:string = "";
		if(task.TaskStatusId === this.taskStatus.Paused){
			dueCompleteSuffix = '(Paused Until)';
		}else if(task.TaskStatusId === this.taskStatus.NC){
			dueCompleteSuffix = '(NC)';
		}else if(task.TaskStatusId === this.taskStatus.UA){
			dueCompleteSuffix = '(UA)';
		}else if(task.TaskStatusId === this.taskStatus.Processing){
			dueCompleteSuffix = '(Processing)';
		}
			return dueCompleteSuffix;
	}
	getStatusClass(taskStatus: number){
		if(taskStatus === this.taskStatus.OverDue){
			return 'overdue';
		}else if(taskStatus === this.taskStatus.Warning){
			return 'warning';
		}else if(taskStatus === this.taskStatus.OnTime){
			return 'ontime';
		}else if(taskStatus === this.taskStatus.Paused){
			return 'paused';
		}else if(taskStatus === this.taskStatus.Processing){
			return 'processing';
		}else{
			return 'complete';
		}
	}
  consolidate(unit: string) {
    return (unit !== null) ? `- ${unit}` : null;
  }

  extendedEventName = (unit: string,eventLabelGroup: string
		,eventLabel: string
		,sequenceNumber: number): string => {
	let extendedEventName: string = '';
	
	if(unit !== null){
		return `- ${unit}`;
	}

	if(eventLabel !== null){
		extendedEventName += `- ${eventLabel}`;
	}
	if(sequenceNumber !== null && Number.isInteger(sequenceNumber) && sequenceNumber >0){
		eventLabelGroup!==null && eventLabelGroup.includes("Repair") ? 
			extendedEventName += ` - Repair - ${sequenceNumber.toString()}`
			: 
			extendedEventName += ` - ${sequenceNumber.toString()}`;
	}

	return extendedEventName;

  }

/* Task Completed by Person full name*/
 completedBy(firstName?: string, lastName?: string): string {
  let completedByFirstName: string;
  let completedByLastName: string;
  completedByFirstName = (firstName !== null ? firstName : '');
  completedByLastName = (lastName !== null ? lastName : '');
  return completedByFirstName  + ' ' +  completedByLastName;
 }

}
